import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import {
  storybookRouteRef,
  systemStatusRouteRef,
  grafanaRouteRef,
} from './routes';

export const dxIframePlugin = createPlugin({
  id: 'dx-iframe',
  routes: {
    root: storybookRouteRef,
    systemStatus: systemStatusRouteRef,
    grafana: grafanaRouteRef,
  },
});

export const DxIframeStorybookPage = dxIframePlugin.provide(
  createRoutableExtension({
    name: 'DxIframeStorybookPage',
    component: () =>
      import('./components/DxIFrameWithStorybookType').then(
        m => m.DxIFrameWithStorybookType,
      ),
    mountPoint: storybookRouteRef,
  }),
);

export const DxIframeSystemStatusPage = dxIframePlugin.provide(
  createRoutableExtension({
    name: 'DxIframeSystemStatusPage',
    component: () =>
      import('./components/DxIFrameWithSystemStatusType').then(
        m => m.DxIFrameWithSystemStatusType,
      ),
    mountPoint: systemStatusRouteRef,
  }),
);

export const DxIframeGrafanaPage = dxIframePlugin.provide(
  createRoutableExtension({
    name: 'DxIframeGrafanaPage',
    component: () =>
      import('./components/DxIFrameWithGrafanaType').then(
        m => m.DxIFrameWithGrafanaType,
      ),
    mountPoint: grafanaRouteRef,
  }),
);
